export function ProductQuantityInit() {
    const qtyInputQuery = 'input.qty';
    const plusButtonQuery = 'button.plus';
    const minusButtonQuery = 'button.minus';
    const formQuery = 'form.cart';

    /**
     * @type {NodeListOf<HTMLFormElement>}
     */
    const forms = document.querySelectorAll(formQuery);

    forms.forEach(form => {

        if (form) {
            /**
             * @type {HTMLInputElement}
             */
            const qtyInput = form.querySelector(qtyInputQuery);
            /**
             * @type {HTMLButtonElement}
             */
            const plusBtn = form.querySelector(plusButtonQuery)
            /**
             * @type {HTMLButtonElement}
             */
            const minusBtn = form.querySelector(minusButtonQuery);

            const max = parseFloat(qtyInput.getAttribute('max'));
            const min = parseFloat(qtyInput.getAttribute('min'));
            const step = parseFloat(qtyInput.getAttribute('step'));


            plusBtn.addEventListener('click', function () {
                const val = parseFloat(qtyInput.value);

                if (max && (max <= val)) {
                    qtyInput.value = max;
                } else {
                    qtyInput.value = val + step;
                }
            })

            minusBtn.addEventListener('click', function () {
                const val = parseFloat(qtyInput.value);

                if (min && (min >= val)) {
                    qtyInput.value = min;
                } else if (val > 1) {
                    qtyInput.value = val - step;
                }
            })

        }
    })

}
